import { createSelector } from '@reduxjs/toolkit';
import params from 'Cloud/Application/Params';
import browser from 'Cloud/browser';
import {
    IS_ANDROID_MOBILE,
    IS_IOS_MOBILE,
    IS_MOBILE_BROWSER,
    IS_MY_TEAM,
    IS_PHONE_BROWSER,
    IS_WEBVIEW,
} from 'reactApp/appHelpers/configHelpers';
import { MAX_WIDTH_AS_PHONE_VIEW_FOR_MYTEAM } from 'reactApp/constants/magicIdentificators';
import { MediaSelectors } from 'reactApp/modules/media/media.selectors';
import { RootState } from 'reactApp/store';

const mobileType = IS_MOBILE_BROWSER;
const isPhone = !!IS_PHONE_BROWSER;
const isWebview = !!IS_WEBVIEW;
const isHuawei = params.getParam('EMORB_VENDOR') === 'Huawei';

const getMobileType = () => (IS_ANDROID_MOBILE ? 'ANDROID' : IS_IOS_MOBILE ? 'IOS' : mobileType);
const isMobile = () => !!getMobileType();

const shouldSimulatePhone = createSelector(
    (state) => state,
    MediaSelectors.getWindowWidth,
    (state, width) => IS_MY_TEAM && width < MAX_WIDTH_AS_PHONE_VIEW_FOR_MYTEAM
);

export const EnvironmentSelectors = {
    isMobile,
    getMobileType,
    isHuawei: () => isHuawei,
    isPhone: (state?: RootState | null) => isPhone || Boolean(state && shouldSimulatePhone(state)),
    isWebview: () => isWebview,
    isIE: () => browser.isIE(),
    isIpadOs: () => browser.isIpadOs(),
    isMac: () => browser.isMac(),
    getIOsVersion: () => browser.getIOsVersion(),
};
